import { createSelector } from 'reselect';

let useWhereToWatchOverride;

if (typeof URLSearchParams !== 'undefined' && typeof location !== 'undefined') {
    const params = new URLSearchParams(location.search);
    const useWhereToWatchParam = params.get('useWhereToWatch');
    if (useWhereToWatchParam !== null) {
        useWhereToWatchOverride = useWhereToWatchParam === 'true';
    }
}
const getUseWhereToWatch = (state) => {
    const { views: { view }, config = {} } = state;
    return useWhereToWatchOverride ?? config[view]?.useWhereToWatch ?? config?.useWhereToWatch ?? false;
};

export default createSelector(
    [getUseWhereToWatch],
    (useWhereToWatch) => useWhereToWatch
);
